import { render, staticRenderFns } from "./AboutGS.vue?vue&type=template&id=2d3b9630&scoped=true"
import script from "./AboutGS.vue?vue&type=script&lang=js"
export * from "./AboutGS.vue?vue&type=script&lang=js"
import style0 from "./AboutGS.vue?vue&type=style&index=0&id=2d3b9630&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3b9630",
  null
  
)

export default component.exports